import {
  Typography,
  TypographyMods,
  TypographySizes,
} from '@vk-cloud-solutions/marketing-ui';
import classNames from 'classnames';

import { Markdown } from '~components/Markdown';
import { ContentBlockWrapper } from '~containers/ArticlePage/ContentBlockWrapper/ContentBlockWrapper';
import QuotesImg from '~public/static/images/quotes.svg';

import styles from './ContentBlockQuote.module.scss';
import { ContentBlockQuoteProps } from './ContentBlockQuote.types';

export function ContentBlockQuote({
  text,
  author,
  ...sectionProps
}: ContentBlockQuoteProps) {
  return (
    <ContentBlockWrapper {...sectionProps}>
      <blockquote className={styles.quote}>
        <div className={classNames(styles.media, styles.media_mobile)}>
          <QuotesImg />
        </div>
        <Markdown className={styles.text}>{text}</Markdown>
        <footer className={styles.footer}>
          {author && (
            <div className={styles.author}>
              <Typography
                tagName={TypographySizes.div}
                mods={[TypographyMods.bodyMAlt]}
                className={styles.authorName}
              >
                {author?.fullName}
              </Typography>
              {author?.description && (
                <Typography
                  tagName={TypographySizes.p}
                  mods={[TypographyMods.bodyS]}
                  className={styles.authorDesc}
                >
                  {author.description}
                </Typography>
              )}
            </div>
          )}
          <div className={classNames(styles.media, styles.media_desktop)}>
            <QuotesImg />
          </div>
        </footer>
      </blockquote>
    </ContentBlockWrapper>
  );
}
